export default "__VITE_ASSET__BjvFX9tw__"